module.exports = __webpack_public_path__ + "img/102.0341da40.jpg";